export default __webpack_public_path__ + "static/media/sunny.70913077.png";